import { Injectable } from "@angular/core";

// Interfaces
import { IService, IContact } from "../../interfaces";

// Services
import { LogService } from "../log/log.service";
import { HelperService } from "../helper/helper.service";

@Injectable()
export class StorageService implements IService {
	// Local variables
	_local: Storage;
	_session: Storage;

	readonly CONTACT: string = "CNTCT-583433";
	readonly KEY_APPLICATIONS: string = "APPSCNTCT-254983";
	readonly KEY_APPLICATION: string = "APPCNTCT-854983";
	readonly KEY_ACCOUNTS_SEARCH: string = "ACTSSRCH-452563";
	readonly KEY_STEPS: string = "STPS-96548";
	readonly KEY_STEP: string = "STP-59548";
	readonly KEY_S3: string = "S3-954321";
	readonly KEY_UPGRADEAPP: string = "UPGRADEAPP-998877";
	readonly TEST_CONTACTS: string = "TSTCNTCTS-358766";
	readonly KEY_PRODUCT: string = "PROD-258463";
	readonly KEY_SALESORDER: string = "SLSORDR-7569582";
	readonly KEY_DISCUSSION_LEGENDS = "D_15223";
	readonly KEY_DISCUSSION_LEGENDSUSER = "D_15224";
	// implements IService
	name = "StorageService";
	test(name, value) {
		console.log("testing", name, value);
	}

	constructor(private _helperSrv: HelperService) {
		this._local = window.localStorage;
		this._session = window.sessionStorage;
	}

	/** gets session storage */
	get session() {
		return this._session;
	}

	/** gets local storage */
	get local() {
		return this._local;
	}

	/**
	 * Gets a session storage
	 * @param key
	 */
	getSession<T>(key: string): T {
		const value = this.session.getItem(key.toUpperCase());
		// 'getting session'.logWithObject(this.name, [key, value]);
		if (value === undefined || value === null) {
			return undefined;
		} else {
			const obj = <T>JSON.parse(value);
			return obj;
		}
	}

	/** sets a key value to session storage */
	setSession(key: string, value: any) {
		// 'setting session'.logWithObject(this.name, [key, value]);
		this._session.setItem(key.toUpperCase(), JSON.stringify(value));
		if (value === undefined) {
			this._session.removeItem(key.toUpperCase());
		}
	}

	/** gets value for a given key */
	getLocal(key: string) {
		const value = this.local.getItem(key.toUpperCase());
		return value;
	}

	/** sets a key value to a local storage */
	setLocal(key: string, value: any) {
		this._local.setItem(key.toUpperCase(), JSON.stringify(value));
	}

	getContact(): IContact {
		const contact = this.GetSessionObject<IContact>(this.CONTACT);
		return contact;
	}

	/**
	 * Gets object from local storage
	 * @param key
	 */
	GetLocalObject<T>(key: string): T {
		const value = this._local.getItem(key.toUpperCase());
		// 'Requesting local value for:'.logWithObject(this.name, [key, value]);
		const obj = <T>JSON.parse(value);
		// 'Requested local value for:'.logWithObject(this.name, [key, obj]);

		return obj;
	}

	/**
	 * Get object from session storage
	 * @param key
	 */
	GetSessionObject<T>(key: string): T {
		const value = this._session.getItem(key.toUpperCase());
		// 'Requesting session value for:'.logWithObject(this.name, [key, value, document.cookie]);

		const obj = <T>JSON.parse(value);
		// 'Requested session value for:'.logWithObject(this.name, [key, obj]);
		return obj;
	}

	GetKey(key: string) {
		const k = this.session.getItem(key);
		if (k !== undefined && k !== null) {
			return k;
		} else {
			this.session.setItem(key, this._helperSrv.getRandomInt(1000, 9999));
			return this.session.getItem(key);
		}
	}

	RemoveKey(key: string) {
		this.session.removeItem(key);
		this.local.removeItem(key);
	}

	AddTestContact(contact: IContact) {
		let contacts = this.getSession<IContact[]>(this.TEST_CONTACTS);
		if (contacts === undefined || contacts === null) {
			contacts = [];
		}
		contacts.push(contact);
		this.setSession(this.TEST_CONTACTS, contacts);
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/storage/storage.service.ts